function setStickyTop( el, headerHeight, viewportHeight ) {
  const elHeight = el.offsetHeight;
  const availableSpace = viewportHeight - headerHeight;
  const topValue = elHeight > availableSpace
    ? headerHeight - ( elHeight - availableSpace )
    : headerHeight;
  el.style.top = `${topValue}px`;
}

function resetStickyStyles( el ) {
  el.style.top = '';
  el.classList.remove( 'is-stucked', 'is-overlapped' );
}

function checkOverlap( el ) {
  if ( !el.classList.contains( 'e-div--text-slide-container' ) || !el
    .classList.contains( 'is-stucked' ) ) {
    el.classList.remove( 'is-overlapped' );
    return;
  }

  const parentSection = el.closest( 'section, div' );
  const nextSection = parentSection?.nextElementSibling;
  const nextTop = nextSection?.getBoundingClientRect().top ?? Infinity;

  el.classList.toggle( 'is-overlapped', nextTop <= 0 );
}

function updateStickyStates( stickyElements, colorChangeElements, triggerPoint ) {
  stickyElements.forEach( el => {
    const rect = el.getBoundingClientRect();
    const isStuck = rect.top <= triggerPoint;
    el.classList.toggle( 'is-stucked', isStuck );
    checkOverlap( el );
  } );
  colorChangeElements.forEach( el => {
    const rect = el.getBoundingClientRect();
    const isStuck = rect.top <= triggerPoint;
    el.classList.toggle( 'is-stucked', isStuck );
    checkOverlap( el );
  } );
}

function adjustAllStickyTops() {
  const header = document.querySelector( '.e-div--header-wrapper' );
  const adminBar = document.querySelector( '#wpadminbar' );
  const stickyElements = document.querySelectorAll( '.e-stn--sticky-top, .e-stn--color-change' );
  const colorChangeElements = document
    .querySelectorAll( '.e-div--text-slide-container' );

  if ( !header || !stickyElements.length ) return;

  const screenWidth = window.innerWidth;
  const adminBarHeight = adminBar?.offsetHeight || 0;
  const headerHeight = header.offsetHeight + adminBarHeight;
  const viewportHeight = window.innerHeight;

  if ( screenWidth <= 1199 ) {
    stickyElements.forEach( resetStickyStyles );
    return;
  }

  const allReady = [...stickyElements].every( el => el.offsetHeight > 0 );
  if ( !allReady ) {
    setTimeout( adjustAllStickyTops, 50 );
    return;
  }

  stickyElements.forEach( el => setStickyTop( el, headerHeight, viewportHeight ) );

  const handleScroll = () => {
    const triggerPoint = window.innerHeight / 1.4;
    updateStickyStates( stickyElements, colorChangeElements, triggerPoint );
  };

  window.removeEventListener( 'scroll', handleScroll );
  window.addEventListener( 'scroll', handleScroll );
  handleScroll();
}

function colorChange() {
  document.querySelectorAll( '.e-stn--color-change, .e-div--text-slide-container' ).forEach( el => {
    const prev = el.previousElementSibling;
    if ( prev ) {
      prev.classList.add( 'e-stn--color-change-prev' );
    }
  } );
}

window.addEventListener( 'load', () => {
  requestAnimationFrame( adjustAllStickyTops );
  colorChange();
} );
window.addEventListener( 'resize', () => {
  adjustAllStickyTops();
  colorChange();
} );
